import type { SuperAdminQueuedRequest } from "@nlc/shared-types";

import { whitelabelRowClassName } from "@/features/requests/constants/accountTags";

import type { TableConfig } from "../../../types/tables";

import { inlineComplexityCell } from "../../helpers/cellRenderers";
import {
  accountCellWithSlotTooltip,
  createdByCell,
  dateCell,
  nameCell,
  requestDesignTypeCell,
  statusCell,
} from "../../helpers/commonCells";

export const queuedTableConfig: TableConfig<SuperAdminQueuedRequest> = {
  columns: [
    {
      accessor: "name",
      cellRenderer: nameCell,
      header: "Name",
      key: "name",
      sortable: true,
      width: 220,
    },
    {
      accessor: "account",
      cellRenderer: accountCellWithSlotTooltip,
      header: "Account",
      key: "account",
      sortable: true,
      width: 180,
    },
    {
      accessor: "status",
      cellRenderer: statusCell, // Read-only: queued tab mixes several statuses
      header: "Status",
      key: "status",
      sortable: true,
      width: 140,
    },
    {
      accessor: "complexity",
      cellRenderer: inlineComplexityCell, // Inline editable
      header: "Complexity",
      key: "complexity",
      sortable: true,
      width: 120,
    },
    {
      accessor: "createdBy",
      cellRenderer: createdByCell,
      header: "Created by",
      key: "createdBy",
      sortable: true,
      width: 140,
    },
    {
      accessor: "createdAt",
      cellRenderer: dateCell,
      header: "Created date",
      key: "createdAt",
      sortable: true,
      width: 130,
    },
    {
      accessor: "designType",
      cellRenderer: requestDesignTypeCell,
      header: "Request/Design type",
      key: "designType",
      sortable: true,
      width: 180,
    },
  ],
  defaultSort: {
    column: "createdAt",
    direction: "desc", // Newest at the top
  },
  enableSorting: true,
  getRowClassName: whitelabelRowClassName,
  id: "superadmin-queued-requests",
  title: "Queued",
};
